import { createSlice } from '@reduxjs/toolkit'
import { apiDeleteFilesFromS3, apiGetPartnerDetails } from 'services/CommonAPI'

export const initialState = {
    currentRouteKey: '',
}

export const commonSlice = createSlice({
	name: 'base/common',
	initialState,
	reducers: {
        setCurrentRouteKey: (state, action) => {
            state.currentRouteKey = action.payload
        }
	},
})

export const deletePreviousFileFromS3 = async (id, SuccessCallBack, ErrorCallBack) => {
    await apiDeleteFilesFromS3(id).then(({ status}) => {
        if (status && status === 200) {
            SuccessCallBack(true)
        } else {
            ErrorCallBack(false)
        }
    }).catch((error) => { ErrorCallBack(false) })
}

  export const GetPartnerDetails = async (id, SuccessCallBack, ErrorCallBack) => {
    await apiGetPartnerDetails(id).then(({ status, data: { data, message } }) => {
        if (status && status === 200) {
            SuccessCallBack({ success: true, message: message, data: data })
        } else {
            ErrorCallBack({ success: false, message: message })
        }
    }).catch(({ message }) => { ErrorCallBack({ success: false, message: message }) })
  }

export const { setCurrentRouteKey } = commonSlice.actions

export default commonSlice.reducer